import { render, staticRenderFns } from "./OrderRefundInputs.vue?vue&type=template&id=5ffbe474&"
import script from "./OrderRefundInputs.vue?vue&type=script&lang=ts&"
export * from "./OrderRefundInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports